module.exports = __webpack_public_path__ + "static/media/round_logo.574654eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/round_logo.png
// module id = 1204
// module chunks = 0